import { Routes, Route } from 'react-router-dom'

import pathUtils from 'utils/pathUtils'
import HireCompanyConstraints from 'views/application/hire_company/constraints'
import HireCompanyOverview from 'views/application/hire_company/overview'


const routes = [
  {
    path: pathUtils.HIRE_COMPANY_OVERVIEW,
    element: <HireCompanyOverview />,
  },
  {
    path: pathUtils.HIRE_COMPANY_CONSTRAINTS,
    element: <HireCompanyConstraints />,
  },
]

const HireCompanyRoutes: React.FC = () => {
  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} {...route} />
      ))}
    </Routes>
  )
}

export default HireCompanyRoutes
